import { css } from 'styled-components';

type ScrollType = 'x' | 'y';

export const scroll = (axis: ScrollType, hideScrollBar: boolean = false) => css`
    overflow: hidden;

    ${axis === 'x' && 'overflow-x: scroll;'}
    ${axis === 'y' && 'overflow-y: scroll;'}
    -webkit-overflow-scrolling: touch;

    ${hideScrollBar &&
    `
        scrollbar-width: none; // hide scroll bar on firefox
        -ms-overflow-style: none; // hide scroll bar on IE 10+
        &::-webkit-scrollbar {
            display: none; // hide scroll bar on Chrome and Safari
        }
    `}
`;

export default scroll;
